


























import { Vue, Component } from 'vue-property-decorator';
import * as api from '@/api';
import { State } from 'vuex-class';
import AddRg from './add-rg.vue';
/**
 * rg header信息
 *
 * @author zhouchangshun
 * @date 01/11/2019
 */
@Component({
    components: {
        AddRg
    }
})
export default class RgInfo extends Vue {
    @State(state => state.cti.permission.rg_entity)
    permission: boolean;

    rgInfo: any = {};
    searchLoading: boolean = false;
    userList: any = [];
    rgId: number = null;
    editRgVisible: Boolean = false;

    mounted() {
        this.rgId = Number(this.$route.query.rgId);
        this.getRgInfo();
    }
    async getRgInfo() {
        try {
            const res = await api.rgApi.getRgList({
                id: this.rgId
            });
            this.rgInfo = res.data.items[0];
            this.remoteMethod(this.rgInfo.owner);
        } catch (e) {
            console.log(e);
        }
    }
    goback() {
        this.$router
            .push({
                name: 'rg'
            })
            .catch(e => e);
    }
    async remoteMethod(query) {
        this.searchLoading = true;
        try {
            const res = await api.rgApi.searchUser({ keyword: query });
            this.userList = res.data.items;
        } catch (e) {
            this.userList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }
}
